import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LanguageState } from 'config/types/configurator'

interface ExtendedLanguageState extends LanguageState {
  loading: boolean
}

const initialState: ExtendedLanguageState = {
  data: {},
  loading: false,
}

const languageSlice = createSlice({
  name: 'languages',
  initialState,
  reducers: {
    setLanguages: (
      state,
      action: PayloadAction<ExtendedLanguageState['data']>
    ) => {
      state.data = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export const { setLanguages, setLoading } = languageSlice.actions
export default languageSlice.reducer
